import { EntityType } from '@frontend/common';
import { ObjectBadge } from '@frontend/components/badge';
import React from 'react';

const ID = 'object-breadcrumb';
export interface ObjectBreadcrumbProps {
    value: string;
    type: string;
}
const defaultClassName = 'text-brand-primary cursor-pointer text-sm text-nowrap opacity-60 hover:opacity-100';

const ObjectBreadcrumb = (props: ObjectBreadcrumbProps) => {
    switch (props.type) {
        case 'accounts':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.ACCOUNT}
                    hideIcon
                />
            );
        case 'brandings':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.BRANDING}
                    hideIcon
                />
            );
        case 'workflows':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.WORKFLOW}
                    hideIcon
                />
            );
        case 'contacts':
        case 'address-book':
        case 'users':
        case 'user':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.USER}
                    hideIcon
                />
            );
        case 'identifications':
        case 'tags':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.IDENTIFICATION}
                    hideIcon
                />
            );
        case 'devices':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.DEVICE}
                    hideIcon
                />
            );
        case 'spots':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.SPOT}
                    hideIcon
                />
            );
        case 'slots':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.SLOT}
                    hideIcon
                />
            );
        case 'slot-templates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.SLOT_TEMPLATE}
                    hideIcon
                />
            );
        case 'modules':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.MODULE}
                    hideIcon
                />
            );
        case 'module-templates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.MODULE_TEMPLATE}
                    hideIcon
                />
            );
        case 'products':
        case 'equipment-products':
        case 'product-kits':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.PRODUCT}
                    hideIcon
                />
            );
        case 'product-categories':
            return (
                <ObjectBadge
                    entityType={EntityType.PRODUCT_CATEGORY}
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    hideIcon
                />
            );
        case 'cost-centers':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.COST_CENTER}
                    hideIcon
                />
            );
        case 'budgets':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.BUDGET}
                    hideIcon
                />
            );
        case 'equipments':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    entityType={EntityType.EQUIPMENT}
                    hideIcon
                />
            );
        case 'requirements':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.REQUIREMENT}
                    hideIcon
                />
            );
        case 'iots':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.IOT}
                    hideIcon
                />
            );
        case 'problems':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.PROBLEM}
                    hideIcon
                />
            );
        case 'stocks':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.STOCK}
                    hideIcon
                />
            );
        case 'movements':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.MOVEMENT}
                    hideIcon
                />
            );
        case 'user-groups':
            return (
                <ObjectBadge
                    entityType={EntityType.USER_GROUP}
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    hideIcon
                />
            );
        case 'questionnaires':
            return (
                <ObjectBadge
                    entityType={EntityType.QUESTIONNAIRE}
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    hideIcon
                />
            );
        case 'equipment-groups':
            return (
                <ObjectBadge
                    entityType={EntityType.EQUIPMENT_GROUP}
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    hideIcon
                />
            );
        case 'product-groups':
            return (
                <ObjectBadge
                    entityType={EntityType.PRODUCT_GROUP}
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    hideIcon
                />
            );
        case 'roles':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.ROLE}
                    hideIcon
                />
            );
        case 'playlists':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.PLAYLIST}
                    hideIcon
                />
            );
        case 'playlist-items':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.PLAYLIST_ITEM}
                    hideIcon
                />
            );
        case 'questions':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.QUESTION}
                    hideIcon
                />
            );
        case 'answers':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.ANSWER}
                    hideIcon
                />
            );
        case 'documents':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.DOCUMENT}
                    hideIcon
                />
            );
        case 'user-interfaces':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.USER_INTERFACE}
                    hideIcon
                />
            );
        case 'transactions':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.TRANSACTION}
                    hideIcon
                />
            );
        case 'packages':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.PACKAGE}
                    hideIcon
                />
            );
        case 'attributes':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.ATTRIBUTE}
                    hideIcon
                />
            );
        case 'certificates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.CERTIFICATE}
                    hideIcon
                />
            );
        case 'user-certificates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.USER_CERTIFICATE}
                    hideIcon
                />
            );
        case 'equipment-certificates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.EQUIPMENT_CERTIFICATE}
                    hideIcon
                />
            );
        case 'label-templates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.LABEL_TEMPLATE}
                    hideIcon
                />
            );
        case 'label-contents':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.LABEL_TEMPLATE_CONTENT}
                    hideIcon
                />
            );
        case 'notification-templates':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.NOTIFICATION_TEMPLATE}
                    hideIcon
                />
            );
        case 'notification-contents':
        case 'content':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.NOTIFICATION_CONTENT}
                    hideIcon
                />
            );
        case 'imports':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.JOB}
                    hideIcon
                />
            );
        case 'reports':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.REPORT}
                    hideIcon
                />
            );
        case 'schedules':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.SCHEDULE}
                    hideIcon
                />
            );
        case 'user-badges':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.IDENTIFICATION}
                    hideIcon
                />
            );
        case 'wizards':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.WIZARD}
                    hideIcon
                />
            );
        case 'rules':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.RULE}
                    hideIcon
                />
            );
        case 'reviews':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.REVIEW}
                    hideIcon
                />
            );
        case 'orders':
            return (
                <ObjectBadge
                    id={props.value}
                    className={defaultClassName}
                    navigateOnDisplayName
                    entityType={EntityType.ORDER}
                    hideIcon
                />
            );
    }

    return <div id={ID}>[placeholder]</div>;
};

export default ObjectBreadcrumb;
